import uVGraduation from './uVGraduation'

export default uVGraduation
